import store from '../../../store'

export default [{
    path: '/app/dashboard',
    component: () => import('../../../components/dashboard/DashboardComponent.vue'),
    children: [

        {
            path: '/app/dashboard',
            name: 'dashboard',
            component: () => (store.state.user.type === 'client') ? import('../../../components/dashboard/client/DashboardComponent.vue') : import('../../../components/dashboard/back-office/DashboardComponent.vue'),
            meta: {
                allowedUsers: ['client', 'back-office']
            }
        },
        {
            path: '/app/approvals',
            redirect: {
                name: 'approvals.manage'
            },
            component: () => import('../../../components/dashboard/client/ApprovalsComponent.vue'),
            children: [{
                    path: '/app/approvals',
                    name: 'approvals.manage',
                    component: () => import('../../../components/dashboard/client/approvals/ManageApprovalsComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/approvals/:request',
                    name: 'approvals.view',
                    component: () => import('../../../components/dashboard/client/approvals/ViewApprovalComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                }
            ]
        },
        {
            path: '/app/documents',
            name: 'documents',
            component: () => (store.state.user.type === 'client') ? import('../../../components/dashboard/client/DocumentsComponent.vue') : import('../../../components/dashboard/back-office/DocumentsComponent.vue'),
            meta: {
                allowedUsers: ['client', 'back-office']
            }
        },
        {
            path: '/app/messages',
            name: 'messages',
            redirect: {
                name: 'messages.inbox'
            },
            component: () => (store.state.user.type === 'client') ? import('../../../components/dashboard/client/MessagesComponent.vue') : import('../../../components/dashboard/back-office/MessagesComponent.vue'),
            children: [

                {
                    path: '/app/messages/inbox',
                    name: 'messages.inbox',
                    component: () => (store.state.user.type === 'client') ? import('../../../components/dashboard/client/messages/InboxComponent.vue') : import('../../../components/dashboard/back-office/messages/InboxComponent.vue'),
                    meta: {
                        allowedUsers: ['client', 'back-office']
                    },
                    children: [{
                        path: '/app/messages/inbox/:id',
                        name: 'messages.inbox.view',
                        component: () => (store.state.user.type === 'client') ? import('../../../components/dashboard/client/messages/ViewMessageComponent.vue') : import('../../../components/dashboard/back-office/messages/ViewMessageComponent.vue'),
                        meta: {
                            allowedUsers: ['client', 'back-office']
                        }
                    }]
                },
                {
                    path: '/app/messages/sent',
                    name: 'messages.sent',
                    component: () => import('../../../components/dashboard/client/messages/SentComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    },
                    children: [{
                        path: '/app/messages/sent/:id',
                        name: 'messages.sent.view',
                        component: () => import('../../../components/dashboard/client/messages/ViewMessageComponent.vue'),
                        meta: {
                            allowedUsers: ['client']
                        }
                    }]
                },
                {
                    path: '/app/messages/new',
                    name: 'messages.new',
                    component: () => import('../../../components/dashboard/client/messages/NewMessageComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },

            ]
        },
        {
            path: '/app/set-new-goal',
            name: 'set-new-goal',
            component: () => import('../../../components/dashboard/client/SetGoalComponent.vue'),
            meta: {
                allowedUsers: ['client']
            }
        },
        {
            path: '/app/fx-rates',
            name: 'fx-rates',
            component: () => import('../../../components/dashboard/back-office/FxRatesComponent.vue'),
            meta: {
                allowedUsers: ['back-office']
            }
        },
        {
            path: '/app/companies',
            redirect: {
                name: 'companies.manage'
            },
            component: () => import('../../../components/dashboard/back-office/CompaniesComponent.vue'),
            children: [{
                    path: '/app/companies',
                    name: 'companies.manage',
                    component: () => import('../../../components/dashboard/back-office/companies/ManageCompaniesComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/companies/new',
                    name: 'companies.new',
                    component: () => import('../../../components/dashboard/back-office/companies/NewCompanyComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/companies/upload',
                    name: 'companies.upload',
                    component: () => import('../../../components/dashboard/back-office/companies/UploadCompaniesComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/companies/attach-user',
                    name: 'companies.attach-user',
                    component: () => import('../../../components/dashboard/back-office/companies/AttachCompanyUserComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/companies/:id',
                    name: 'companies.show',
                    component: () => import('../../../components/dashboard/back-office/companies/ViewCompanyComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                }
            ]
        },
        {
            path: '/app/requests',
            name: 'requests',
            redirect: {
                name: 'requests.manage'
            },
            component: () => import('../../../components/dashboard/back-office/RequestsComponent.vue'),
            children: [{
                    path: '/app/requests',
                    name: 'requests.manage',
                    component: () => import('../../../components/dashboard/back-office/requests/ManageRequestsComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/requests/:id',
                    name: 'requests.show',
                    component: () => import('../../../components/dashboard/back-office/requests/ViewRequestComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
            ]
        },
        {
            path: '/app/fees',
            name: 'fees',
            component: () =>
                import(
                    '../../../components/dashboard/client/portfolio/PortfolioFeesComponent.vue'
                ),
            meta: {
                allowedUsers: ['client']
            }
        },
        // {
        //     path: '/app/fees',
        //     redirect: {
        //         name: 'fees.manage'
        //     },
        //     component: () => import('../../../components/dashboard/back-office/FeesComponent.vue'),
        //     children: [{
        //             path: '/app/fees',
        //             name: 'fees.manage',
        //             component: () => import('../../../components/dashboard/back-office/fees/ManageFeesComponent.vue'),
        //             meta: {
        //                 allowedUsers: ['back-office']
        //             }
        //         },
        //         {
        //             path: '/app/fees/new',
        //             name: 'fees.new',
        //             component: () => import('../../../components/dashboard/back-office/fees/NewFeeComponent.vue'),
        //             meta: {
        //                 allowedUsers: ['back-office']
        //             }
        //         },
        //         {
        //             path: '/app/fees/upload',
        //             name: 'fees.upload',
        //             component: () => import('../../../components/dashboard/back-office/fees/UploadFeesComponent.vue'),
        //             meta: {
        //                 allowedUsers: ['back-office']
        //             }
        //         },
        //         {
        //             path: '/app/fees/:id',
        //             name: 'fees.show',
        //             component: () => import('../../../components/dashboard/back-office/fees/ViewFeeComponent.vue'),
        //             meta: {
        //                 allowedUsers: ['back-office']
        //             }
        //         },
        //     ]
        // },
        {
            path: '/app/transactions',
            redirect: {
                name: 'transactions.manage'
            },
            component: () => import('../../../components/dashboard/back-office/TransactionsComponent.vue'),
            children: [{
                    path: '/app/transactions',
                    name: 'transactions.manage',
                    component: () => import('../../../components/dashboard/back-office/transactions/ManageTransactionsComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/transactions/new',
                    name: 'transactions.new',
                    component: () => import('../../../components/dashboard/back-office/transactions/NewTransactionComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/transactions/upload',
                    name: 'transactions.upload',
                    component: () => import('../../../components/dashboard/back-office/transactions/UploadTransactionsComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/transactions/:id',
                    name: 'transactions.show',
                    component: () => import('../../../components/dashboard/back-office/transactions/ViewTransactionComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
            ]
        },

    ]
}]
